import { render, staticRenderFns } from "./editSimple.vue?vue&type=template&id=0c21c0f0&scoped=true"
import script from "./editSimple.vue?vue&type=script&lang=js"
export * from "./editSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21c0f0",
  null
  
)

export default component.exports